module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_opinions_ghazala-khan-donald-trump-criticized-my-silence-he-knows-nothing-about-true-sacrifice_2016_07_31_c46e52ec-571c-11e6-831d-0324760ca856_story.html_plot.a08b0330.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_opinions_ghazala-khan-donald-trump-criticized-my-silence-he-knows-nothing-about-true-sacrifice_2016_07_31_c46e52ec-571c-11e6-831d-0324760ca856_story.html_plot.png
// module id = 438
// module chunks = 0